import { useMsal } from '@azure/msal-react';
import { useProjectId } from '@consigli/hooks';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { MicrosoftAuthButton } from '@/components/microsoft-auth-button';
import { WorkspaceProvider } from '@/layouts/workspace-layout/use-workspace-context';
import { WorkspaceLayout } from '@/layouts/workspace-layout/workspace-layout';

export const MeetingSecretaryDetailWrapper = () => {
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const { t } = useTranslation();
  const projectId = useProjectId();

  if (!isAuthenticated) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4">
        <div className="w-full max-w-md space-y-8 bg-white shadow-lg rounded-xl p-8 border border-gray-200">
          <div className="space-y-2 text-center">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900">
              {t('services.meeting-secretary')}
            </h1>
            <p className="text-sm text-gray-600">
              {t('meeting-secretary.header.microsoft-auth-header')}
            </p>
          </div>
          <MicrosoftAuthButton className="w-full" />
          <p className="text-xs text-gray-400 text-center">
            {t('meeting-secretary.header.microsoft-auth-description')}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-row w-full max-w-[2000px] mx-auto">
      <WorkspaceProvider>
        <WorkspaceLayout hideTabs={false}>
          {/* Keyed by projectId so switching projects remounts the routed page.
              This clears previous-project state (e.g. a selected meeting from the
              old project) that would otherwise fire tasks against the new project. */}
          <Fragment key={projectId}>
            <Outlet />
          </Fragment>
        </WorkspaceLayout>
      </WorkspaceProvider>
    </div>
  );
};
